import ChineseCode from "!!raw-loader!./text/Chinese.tsx";
import DisplayCode from "!!raw-loader!./text/Display.tsx";
import LocalizedCode from "!!raw-loader!./text/Localized.tsx";
import OverflowCode from "!!raw-loader!./text/Overflow.tsx";
import SizeCode from "!!raw-loader!./text/Size.tsx";
import TransformCode from "!!raw-loader!./text/Transform.tsx";
import WeightCode from "!!raw-loader!./text/Weight.tsx";
import TypographyCode from "!!raw-loader!./text/Typography.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import Chinese from "./text/Chinese";
import Display from "./text/Display";
import Localized from "./text/Localized";
import Overflow from "./text/Overflow";
import Size from "./text/Size";
import Transform from "./text/Transform";
import Weight from "./text/Weight";
import Typography from "./text/Typography";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Display", DisplayCode, Display),
		paneComponent("Localized", LocalizedCode, Localized),
		paneComponent("Overflow", OverflowCode, Overflow),
		paneComponent("Size", SizeCode, Size),
		paneComponent("Transform", TransformCode, Transform),
		paneComponent("Weight", WeightCode, Weight),
		paneComponent("Typography", TypographyCode, Typography),
		paneComponent("Chinese", ChineseCode, Chinese),
	];

	return (
		<Pane
			components={components}
			imports='import {OverflowText, Text} from "designSystem/index";'
			muiApi="typography"
			muiComponent="typography"
			{...props}
		/>
	);
};